module.exports = __webpack_public_path__ + "img/icon-action-account-circle-24-px.2c6a98f8.svg";